import { render, staticRenderFns } from "./returnGoodsDialog.vue?vue&type=template&id=c1209366&scoped=true&"
import script from "./returnGoodsDialog.vue?vue&type=script&lang=js&"
export * from "./returnGoodsDialog.vue?vue&type=script&lang=js&"
import style0 from "./returnGoodsDialog.vue?vue&type=style&index=0&id=c1209366&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1209366",
  null
  
)

export default component.exports